import { useEffect, useState } from 'react';
import { graphql, activeOrganizationId } from '../api/client';
import { useAuth } from '../auth/AuthProvider';

export function useWorkspaceRead<T>(field: 'customerJobs' | 'billingWorkspace', input: Record<string, unknown>) {
  const {token}=useAuth();
  const serialized=JSON.stringify(input),key=JSON.stringify([field,serialized,token]);
  const [result,setResult]=useState<{key:string;data?:T;error:string}>();
  useEffect(()=>{
    let active=true;
    const refresh=()=>{
      if(!token)return;
      void graphql<Record<string,T>>({query:`query Read($input:JSON){${field}(input:$input)}`,variables:{input:JSON.parse(serialized)},token,organizationId:activeOrganizationId()})
        .then(value=>{if(active)setResult({key,data:value[field],error:''});})
        .catch(reason=>{if(active)setResult({key,error:(reason as Error).message});});
    };
    refresh();window.addEventListener('payright-workspace-changed',refresh);
    return()=>{active=false;window.removeEventListener('payright-workspace-changed',refresh);};
  },[token,field,serialized,key]);
  return {data:result?.key===key?result.data:undefined,error:result?.key===key?result.error:'',loading:result?.key!==key,refresh:()=>window.dispatchEvent(new Event('payright-workspace-changed'))};
}
